import { action } from "../const";

let initialState = {
    daily_task: null,
    daily_riddle: null,
    members_progress: null
}

export default function Main(state = initialState, arg) {

    switch (arg.type) {

        case action.GET_DAILY_TASK:
            return { ...state, daily_task: arg.payload }
        case action.GET_MEMBERS_PROGRESS:
            return { ...state, members_progress: arg.payload }
        case action.GET_DAILY_RIDDLE:
            return { ...state, daily_riddle: arg.payload }

        default:
            break;
    }
    return state;
}